__webpack_require__.p = "/kalkulatori-gail/";